<template>
  <button
    class="st-back-button"
    tabindex="0"
    @click="useRoute ? $router.push(route) : $router.go(-1)"
  >
    <arrow-left-icon /><span class="st-back-button__text">Tillbaka</span>
  </button>
</template>

<script>
import ArrowLeftIcon from "../../icons/st/arrow-left-icon";

export default {
  name: "st-back-button",
  props: {
    route: String,
    useRoute: {
      default: true,
      type: Boolean,
    },
  },
  components: {
    ArrowLeftIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-back-button {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  line-height: rem-calc(20);
  font-weight: 400;
  font-size: rem-calc(16);
  text-decoration: underline;
  font-family: $source-sans-pro;
  color: $dark-grey;
  cursor: pointer;
  &:focus {
    outline-color: $dark-grey;
  }
  &__text {
    margin-left: rem-calc(10);
  }
}
</style>
